export default __webpack_public_path__ + "static/media/web-ic.b4742cbc.png";